var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme, TRANSITION } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { FormFieldPassword } from './form-field-text';
import { useLang } from '../hooks/use-lang';
import { OnboardingButton } from './onboarding-button';
import { CrossIcon, TickIcon } from '@shapeable/icons';
var cls = classNames('update-password-login-form-layout');
export var UpdatePasswordFormLayoutDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n    align-items: center;\n    width: 100%;\n  "], ["\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n    align-items: center;\n    width: 100%;\n  "])), theme.UNIT(9))
});
var HeaderStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: ", ";\n  "], ["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: ", ";\n  "])), theme.UNIT(4))
});
var PretitleStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin: 0;\n    font-weight: 300;\n    text-align: center;\n  "], ["\n    margin: 0;\n    font-weight: 300;\n    text-align: center;\n  "])))
});
var TitleStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    margin: 0;\n    font-weight: 300;\n    text-align: center;\n    font-family: ", ";\n  "], ["\n    margin: 0;\n    font-weight: 300;\n    text-align: center;\n    font-family: ", ";\n  "])), theme.FONT('serif'))
});
var FormStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: ", ";\n    width: 60%;\n  "], ["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: ", ";\n    width: 60%;\n  "])), theme.UNIT(3))
});
var PasswordStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    width: 100%;\n  "], ["\n    width: 100%;\n  "])))
});
var ButtonsStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    gap: ", ";\n    width: 100%;\n    font-family: ", ";\n  "], ["\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    gap: ", ";\n    width: 100%;\n    font-family: ", ";\n  "])), theme.UNIT(4), theme.FONT('sans'))
});
var ContinueStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n\n    &:hover {\n      cursor: pointer;\n      filter: brightness(1.1);\n      ", "\n    }\n  "], ["\n\n    &:hover {\n      cursor: pointer;\n      filter: brightness(1.1);\n      ", "\n    }\n  "])), TRANSITION('filter'))
});
var PreviousButtonStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n\n\n  "], ["\n\n\n  "])))
});
var ErrorMessageStyles = breakpoints({
  base: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin: 0;\n  "], ["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin: 0;\n  "])))
});
var ErrorItemsStyles = breakpoints({
  base: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    padding: 0;\n  "], ["\n    padding: 0;\n  "])))
});
var ErrorItemStyles = breakpoints({
  base: css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    gap: ", ";\n  "], ["\n    display: flex;\n    align-items: center;\n    gap: ", ";\n  "])), theme.UNIT(2))
});
// -------- Components -------->
var My = {
  NAME: 'UpdatePasswordFormLayout',
  Container: styled.div(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Header: styled.div(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), HeaderStyles),
  Pretitle: styled.h3(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), PretitleStyles),
  Title: styled.h1(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  Form: styled.form(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), FormStyles),
  Password: styled(FormFieldPassword).attrs({
    id: 'Password',
    placeholder: ''
  })(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), PasswordStyles),
  Buttons: styled.div(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), ButtonsStyles),
  ContinueButton: styled(OnboardingButton)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), ContinueStyles),
  PreviousButton: styled(OnboardingButton)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), PreviousButtonStyles),
  ErrorMessage: styled.div(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), ErrorMessageStyles),
  ErrorItems: styled.ul(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), ErrorItemsStyles),
  ErrorItem: styled.li(templateObject_24 || (templateObject_24 = __makeTemplateObject(["", ""], ["", ""])), ErrorItemStyles)
};
export var UpdatePasswordFormLayout = function (props) {
  var componentProps = useComponentProps(My.NAME, props, UpdatePasswordFormLayoutDefaultProps);
  var className = componentProps.className,
    children = componentProps.children,
    entity = componentProps.entity,
    goToPreviousStep = componentProps.goToPreviousStep,
    onSubmit = componentProps.onSubmit,
    title = componentProps.title;
  var t = useLang();
  var _a = __read(useState({
      newPassword: '',
      confirmPassword: ''
    }), 2),
    passwords = _a[0],
    setPasswords = _a[1];
  var validatePasswordWithStatus = function (password) {
    return [{
      message: 'At least 8 characters long',
      valid: password.length >= 8
    }, {
      message: 'At least one lowercase letter (a-z)',
      valid: /[a-z]/.test(password)
    }, {
      message: 'At least one uppercase letter (A-Z)',
      valid: /[A-Z]/.test(password)
    }, {
      message: 'At least one number (0-9)',
      valid: /\d/.test(password)
    }, {
      message: 'At least one special character (!@#$^&*)',
      valid: /[!@#$%^&*()_\-+={[}\]|:;"'<,>.?/]/.test(password)
    }];
  };
  var _b = __read(useState(null), 2),
    errors = _b[0],
    setErrors = _b[1];
  var handleInputChange = function (result) {
    var value = result.value,
      mutationValue = result.mutationValue,
      error = result.error,
      event = result.event;
    if (error) {
      console.error("Validation error:", error);
      return;
    }
    var finalValue = mutationValue !== undefined ? mutationValue : value;
    setPasswords(function (prevPasswords) {
      var _a;
      return __assign(__assign({}, prevPasswords), (_a = {}, _a[event === null || event === void 0 ? void 0 : event.target.name] = finalValue, _a));
    });
  };
  var handleSubmit = function (e) {
    e.preventDefault();
    var newPassword = passwords.newPassword,
      confirmPassword = passwords.confirmPassword;
    if (newPassword !== confirmPassword) {
      setErrors([{
        message: 'Passwords do not match',
        valid: false
      }]);
      setPasswords({
        newPassword: '',
        confirmPassword: ''
      });
      return;
    }
    var passwordValidationResults = validatePasswordWithStatus(newPassword);
    var allValid = passwordValidationResults.every(function (rule) {
      return rule.valid;
    });
    if (!allValid) {
      setErrors(passwordValidationResults);
      return;
    }
    if (onSubmit) {
      onSubmit(newPassword);
    }
  };
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Form, {
    onSubmit: handleSubmit,
    method: "post",
    name: 'test'
  }, React.createElement(My.Password, {
    id: "update-password",
    name: 'newPassword',
    newPlaceholder: 'Enter new password',
    value: passwords.newPassword,
    onChange: handleInputChange,
    autoComplete: 'new-password'
  }), React.createElement(My.Password, {
    id: "confirm-password",
    name: 'confirmPassword',
    newPlaceholder: 'Confirm password',
    value: passwords.confirmPassword,
    onChange: handleInputChange,
    autoComplete: 'new-password'
  }), errors && Array.isArray(errors) && React.createElement(My.ErrorMessage, null, React.createElement(My.ErrorItems, null, errors.map(function (rule, index) {
    return React.createElement(My.ErrorItem, {
      key: index
    }, rule.valid ? React.createElement(TickIcon, {
      size: 17,
      colors: {
        fill: "green"
      }
    }) : React.createElement(CrossIcon, {
      size: 17,
      colors: {
        fill: "red"
      }
    }), rule.message);
  })))), React.createElement(My.Buttons, null, React.createElement(My.ContinueButton, {
    colors: {
      background: 'primary',
      text: 'light',
      hover: {
        background: 'primary',
        text: 'light'
      }
    },
    onClick: handleSubmit
  }, t('Submit')), React.createElement(My.PreviousButton, {
    colors: {
      background: 'transparent',
      text: 'strong',
      hover: {
        background: 'very-subtle'
      }
    },
    onClick: goToPreviousStep
  }, t('Back'))));
};
UpdatePasswordFormLayout.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24;